"use strict";
// Alternative to Util.FullDateStr usage of template literals
// Not as type-strict, but avoids too many unions compilation error
Object.defineProperty(exports, "__esModule", { value: true });
exports.SftpConfigSchema = exports.EncryptionConfigSchema = exports.EncryptionTypeSchema = exports.FrequencyType = exports.FrequencyTypeIterable = exports.FrequencyPeriod = exports.FrequencyPeriodIterable = exports.DateTimeZones = exports.DateTimeZonesIterable = exports.SqlPrimitiveStruct = exports.PrimitiveForJsonSchemaStruct = exports.PrimitiveStruct = exports.TextFormatEnum = exports.TextFormatIterable = exports.PercentageFormatEnum = exports.PercentageFormatIterable = exports.CurrencyFormatEnum = exports.CurrencyFormatIterable = exports.DateFormatEnum = exports.DateFormatIterable = exports.FormatTypeEnum = exports.FormatTypeIterable = exports.isSupportedFileExtension = exports.SupportedFileExtensionSchema = exports.SupportedFileExtensionIterable = exports.OutputReportFileExtensionSchema = exports.OutputReportFileExtensionIterable = exports.ZodFullDateStrForJsonSchemaStruct = exports.ZodFullDateStrLightWeightStruct = exports.ZodFullDateStrStruct = void 0;
const zod_1 = require("zod");
const ZodPaddedNumber = zod_1.z.templateLiteral([
    zod_1.z.union([zod_1.z.literal('0'), zod_1.z.literal('')]),
    zod_1.z.number(),
]);
exports.ZodFullDateStrStruct = zod_1.z
    .templateLiteral([zod_1.z.number(), '-', ZodPaddedNumber, '-', ZodPaddedNumber])
    .refine((val) => /^\d{4}-\d{2}-\d{2}$/.test(val), {
    error: 'Invalid date format, must be YYYY-MM-DD',
})
    .refine((date) => {
    const [year, month, day] = date.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    return (dateObj.getFullYear() === year &&
        dateObj.getMonth() + 1 === month &&
        dateObj.getDate() === day);
}, { error: 'Invalid date value' });
// when possible, use ZodFullDateStrStruct, as it contains a richer validation of FullDateStr
// however, it does not codegen well into our static jsonschema files that the CA currently uses
// this lightweight struct serves as zod replacement to our existing FullDateStr, until we can entirely
// move away from codegen jsonschema file\
// ideally this is only needed temporarily as we transition the CA to zod schema.
exports.ZodFullDateStrLightWeightStruct = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format, must be YYYY-MM-DD');
/**
 * A Zod schema that maintains the FullDateStr type for TypeScript compatibility
 * but generates proper JSON schemas (solution to ZodFullDateStrStruct).
 * This is the recommended struct for types that need JSON schema generation.
 *
 * Uses the lightweight regex pattern that generates proper JSON schema,
 * but extends it with the FullDateStr type for TypeScript compatibility.
 */
exports.ZodFullDateStrForJsonSchemaStruct = zod_1.z.custom((val) => {
    if (typeof val !== 'string')
        return false;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(val))
        return false;
    // Runtime validation same as ZodFullDateStrStruct
    const [year, month, day] = val.split('-').map(Number);
    const dateObj = new Date(year, month - 1, day);
    return (dateObj.getFullYear() === year &&
        dateObj.getMonth() + 1 === month &&
        dateObj.getDate() === day);
}, { message: 'Invalid date format, must be YYYY-MM-DD' });
exports.OutputReportFileExtensionIterable = [
    'csv',
    'xlsx',
    'xlsb',
    'xlsm',
    'json',
    'docx',
    'pdf',
    'png',
    'txt',
    'zip',
];
exports.OutputReportFileExtensionSchema = zod_1.z.enum(exports.OutputReportFileExtensionIterable);
exports.SupportedFileExtensionIterable = [
    'csv',
    'json',
    'xls',
    'xlsx',
    'XLSX',
    'xlsb',
    'xlsm',
    'pdf',
    'txt',
    'zip',
    'html',
    'tif',
    'tiff',
    'jpeg',
    'jpg',
    'png',
    'gz',
    'pgp',
    'gpg',
];
exports.SupportedFileExtensionSchema = zod_1.z.enum(exports.SupportedFileExtensionIterable);
const isSupportedFileExtension = (value) => exports.SupportedFileExtensionSchema.safeParse(value).success;
exports.isSupportedFileExtension = isSupportedFileExtension;
exports.FormatTypeIterable = [
    'currency',
    'percentage',
    'date',
    'text',
];
/**
 * Object with named keys for FormatType values.
 */
exports.FormatTypeEnum = {
    currency: 'currency',
    percentage: 'percentage',
    date: 'date',
    text: 'text',
};
// TODO: do we really need to limit to certain formats
// can we check these more dynamically?
exports.DateFormatIterable = [
    'L/d/yy',
    'LL/dd/yyyy',
    'LL/dd/yy',
    'L/d/yyyy',
    'L-d-yyyy',
    'L-d-yy',
    'L-dd-yy',
    'L-dd-yyyy',
    'L/dd/yyyy',
    'L/dd/yy',
    'LL-dd-yyyy',
    'LLL dd, yyyy',
    'LLLL d yyyy',
    'LLLL d, yyyy',
    'dd LLLL, yyyy',
    'yyyy-L-dd',
    'yyyy-LL-dd',
    'YYYY/LL/DD',
    'M/d/y hh:mm:ss a', // @chris TODO: remove me when we remove these formats, toolbox specific date format
];
/**
 * Object with named keys for DateFormat values.
 */
exports.DateFormatEnum = {
    'L/d/yy': 'L/d/yy',
    'LL/dd/yyyy': 'LL/dd/yyyy',
    'LL/dd/yy': 'LL/dd/yy',
    'L/d/yyyy': 'L/d/yyyy',
    'L-d-yyyy': 'L-d-yyyy',
    'L-d-yy': 'L-d-yy',
    'L-dd-yy': 'L-dd-yy',
    'L-dd-yyyy': 'L-dd-yyyy',
    'L/dd/yyyy': 'L/dd/yyyy',
    'L/dd/yy': 'L/dd/yy',
    'LL-dd-yyyy': 'LL-dd-yyyy',
    'LLL dd, yyyy': 'LLL dd, yyyy',
    'LLLL d yyyy': 'LLLL d yyyy',
    'LLLL d, yyyy': 'LLLL d, yyyy',
    'dd LLLL, yyyy': 'dd LLLL, yyyy',
    'yyyy-L-dd': 'yyyy-L-dd',
    'yyyy-LL-dd': 'yyyy-LL-dd',
    'YYYY/LL/DD': 'YYYY/LL/DD',
    'M/d/y hh:mm:ss a': 'M/d/y hh:mm:ss a',
};
exports.CurrencyFormatIterable = [
    'thousandsWithCommasAndDecimalCents',
    'decimalCents',
    'thousandsCommas',
    'thousandsWithCommasAndDecimalCentsAndSymbol',
];
/**
 * Object with named keys for CurrencyFormat values.
 */
exports.CurrencyFormatEnum = {
    thousandsWithCommasAndDecimalCents: 'thousandsWithCommasAndDecimalCents',
    decimalCents: 'decimalCents',
    thousandsCommas: 'thousandsCommas',
    thousandsWithCommasAndDecimalCentsAndSymbol: 'thousandsWithCommasAndDecimalCentsAndSymbol',
};
exports.PercentageFormatIterable = [
    'rawDecimal',
    'formattedPercentage',
];
/**
 * Object with named keys for PercentageFormat values.
 */
exports.PercentageFormatEnum = {
    rawDecimal: 'rawDecimal',
    formattedPercentage: 'formattedPercentage',
};
exports.TextFormatIterable = [
    'lowerCase',
    'allCaps',
    'sentenceCase',
    'titleCase',
    'none',
];
/**
 * Object with named keys for TextFormat values.
 */
exports.TextFormatEnum = {
    lowerCase: 'lowerCase',
    allCaps: 'allCaps',
    sentenceCase: 'sentenceCase',
    titleCase: 'titleCase',
    none: 'none',
};
// Zod struct for Primitive type - includes string (which covers FullDateStr/FullDateTimeStr at runtime)
exports.PrimitiveStruct = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.boolean(),
    zod_1.z.number(),
    zod_1.z.null(),
    zod_1.z.undefined(),
]);
// JSON Schema compatible version - excludes undefined since JSON doesn't support undefined
// Use this for types that need JSON schema generation for Python codegen
exports.PrimitiveForJsonSchemaStruct = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.boolean(),
    zod_1.z.number(),
    zod_1.z.null(),
]);
exports.SqlPrimitiveStruct = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.null(),
]);
// IANA time zones: https://stackoverflow.com/questions/38399465/how-to-get-list-of-all-timezones-in-javascript
exports.DateTimeZonesIterable = [
    'Europe/Andorra',
    'Asia/Dubai',
    'Asia/Kabul',
    'Europe/Tirane',
    'Asia/Yerevan',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Mawson',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Cordoba',
    'America/Argentina/Salta',
    'America/Argentina/Jujuy',
    'America/Argentina/Tucuman',
    'America/Argentina/Catamarca',
    'America/Argentina/La_Rioja',
    'America/Argentina/San_Juan',
    'America/Argentina/Mendoza',
    'America/Argentina/San_Luis',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Ushuaia',
    'Pacific/Pago_Pago',
    'Europe/Vienna',
    'Australia/Lord_Howe',
    'Antarctica/Macquarie',
    'Australia/Hobart',
    'Australia/Currie',
    'Australia/Melbourne',
    'Australia/Sydney',
    'Australia/Broken_Hill',
    'Australia/Brisbane',
    'Australia/Lindeman',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Perth',
    'Australia/Eucla',
    'Asia/Baku',
    'America/Barbados',
    'Asia/Dhaka',
    'Europe/Brussels',
    'Europe/Sofia',
    'Atlantic/Bermuda',
    'Asia/Brunei',
    'America/La_Paz',
    'America/Noronha',
    'America/Belem',
    'America/Fortaleza',
    'America/Recife',
    'America/Araguaina',
    'America/Maceio',
    'America/Bahia',
    'America/Sao_Paulo',
    'America/Campo_Grande',
    'America/Cuiaba',
    'America/Santarem',
    'America/Porto_Velho',
    'America/Boa_Vista',
    'America/Manaus',
    'America/Eirunepe',
    'America/Rio_Branco',
    'America/Nassau',
    'Asia/Thimphu',
    'Europe/Minsk',
    'America/Belize',
    'America/St_Johns',
    'America/Halifax',
    'America/Glace_Bay',
    'America/Moncton',
    'America/Goose_Bay',
    'America/Blanc-Sablon',
    'America/Toronto',
    'America/Nipigon',
    'America/Thunder_Bay',
    'America/Iqaluit',
    'America/Pangnirtung',
    'America/Atikokan',
    'America/Winnipeg',
    'America/Rainy_River',
    'America/Resolute',
    'America/Rankin_Inlet',
    'America/Regina',
    'America/Swift_Current',
    'America/Edmonton',
    'America/Cambridge_Bay',
    'America/Yellowknife',
    'America/Inuvik',
    'America/Creston',
    'America/Dawson_Creek',
    'America/Fort_Nelson',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Dawson',
    'Indian/Cocos',
    'Europe/Zurich',
    'Africa/Abidjan',
    'Pacific/Rarotonga',
    'America/Santiago',
    'America/Punta_Arenas',
    'Pacific/Easter',
    'Asia/Shanghai',
    'Asia/Urumqi',
    'America/Bogota',
    'America/Costa_Rica',
    'America/Havana',
    'Atlantic/Cape_Verde',
    'America/Curacao',
    'Indian/Christmas',
    'Asia/Nicosia',
    'Asia/Famagusta',
    'Europe/Prague',
    'Europe/Berlin',
    'Europe/Copenhagen',
    'America/Santo_Domingo',
    'Africa/Algiers',
    'America/Guayaquil',
    'Pacific/Galapagos',
    'Europe/Tallinn',
    'Africa/Cairo',
    'Africa/El_Aaiun',
    'Europe/Madrid',
    'Africa/Ceuta',
    'Atlantic/Canary',
    'Europe/Helsinki',
    'Pacific/Fiji',
    'Atlantic/Stanley',
    'Pacific/Chuuk',
    'Pacific/Pohnpei',
    'Pacific/Kosrae',
    'Atlantic/Faroe',
    'Europe/Paris',
    'Europe/London',
    'Asia/Tbilisi',
    'America/Cayenne',
    'Africa/Accra',
    'Europe/Gibraltar',
    'America/Godthab',
    'America/Danmarkshavn',
    'America/Scoresbysund',
    'America/Thule',
    'Europe/Athens',
    'Atlantic/South_Georgia',
    'America/Guatemala',
    'Pacific/Guam',
    'Africa/Bissau',
    'America/Guyana',
    'Asia/Hong_Kong',
    'America/Tegucigalpa',
    'America/Port-au-Prince',
    'Europe/Budapest',
    'Asia/Jakarta',
    'Asia/Pontianak',
    'Asia/Makassar',
    'Asia/Jayapura',
    'Europe/Dublin',
    'Asia/Jerusalem',
    'Asia/Kolkata',
    'Indian/Chagos',
    'Asia/Baghdad',
    'Asia/Tehran',
    'Atlantic/Reykjavik',
    'Europe/Rome',
    'America/Jamaica',
    'Asia/Amman',
    'Asia/Tokyo',
    'Africa/Nairobi',
    'Asia/Bishkek',
    'Pacific/Tarawa',
    'Pacific/Enderbury',
    'Pacific/Kiritimati',
    'Asia/Pyongyang',
    'Asia/Seoul',
    'Asia/Almaty',
    'Asia/Qyzylorda',
    'Asia/Qostanay',
    'Asia/Aqtobe',
    'Asia/Aqtau',
    'Asia/Atyrau',
    'Asia/Oral',
    'Asia/Beirut',
    'Asia/Colombo',
    'Africa/Monrovia',
    'Europe/Vilnius',
    'Europe/Luxembourg',
    'Europe/Riga',
    'Africa/Tripoli',
    'Africa/Casablanca',
    'Europe/Monaco',
    'Europe/Chisinau',
    'Pacific/Majuro',
    'Pacific/Kwajalein',
    'Asia/Yangon',
    'Asia/Ulaanbaatar',
    'Asia/Hovd',
    'Asia/Choibalsan',
    'Asia/Macau',
    'America/Martinique',
    'Europe/Malta',
    'Indian/Mauritius',
    'Indian/Maldives',
    'America/Mexico_City',
    'America/Cancun',
    'America/Merida',
    'America/Monterrey',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Chihuahua',
    'America/Ojinaga',
    'America/Hermosillo',
    'America/Tijuana',
    'America/Bahia_Banderas',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Africa/Maputo',
    'Africa/Windhoek',
    'Pacific/Noumea',
    'Pacific/Norfolk',
    'Africa/Lagos',
    'America/Managua',
    'Europe/Amsterdam',
    'Europe/Oslo',
    'Asia/Kathmandu',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'America/Panama',
    'America/Lima',
    'Pacific/Tahiti',
    'Pacific/Marquesas',
    'Pacific/Gambier',
    'Pacific/Port_Moresby',
    'Pacific/Bougainville',
    'Asia/Manila',
    'Asia/Karachi',
    'Europe/Warsaw',
    'America/Miquelon',
    'Pacific/Pitcairn',
    'America/Puerto_Rico',
    'Asia/Gaza',
    'Asia/Hebron',
    'Europe/Lisbon',
    'Atlantic/Madeira',
    'Atlantic/Azores',
    'Pacific/Palau',
    'America/Asuncion',
    'Asia/Qatar',
    'Indian/Reunion',
    'Europe/Bucharest',
    'Europe/Belgrade',
    'Europe/Kaliningrad',
    'Europe/Moscow',
    'Europe/Simferopol',
    'Europe/Kirov',
    'Europe/Astrakhan',
    'Europe/Volgograd',
    'Europe/Saratov',
    'Europe/Ulyanovsk',
    'Europe/Samara',
    'Asia/Yekaterinburg',
    'Asia/Omsk',
    'Asia/Novosibirsk',
    'Asia/Barnaul',
    'Asia/Tomsk',
    'Asia/Novokuznetsk',
    'Asia/Krasnoyarsk',
    'Asia/Irkutsk',
    'Asia/Chita',
    'Asia/Yakutsk',
    'Asia/Khandyga',
    'Asia/Vladivostok',
    'Asia/Ust-Nera',
    'Asia/Magadan',
    'Asia/Sakhalin',
    'Asia/Srednekolymsk',
    'Asia/Kamchatka',
    'Asia/Anadyr',
    'Asia/Riyadh',
    'Pacific/Guadalcanal',
    'Indian/Mahe',
    'Africa/Khartoum',
    'Europe/Stockholm',
    'Asia/Singapore',
    'America/Paramaribo',
    'Africa/Juba',
    'Africa/Sao_Tome',
    'America/El_Salvador',
    'Asia/Damascus',
    'America/Grand_Turk',
    'Africa/Ndjamena',
    'Indian/Kerguelen',
    'Asia/Bangkok',
    'Asia/Dushanbe',
    'Pacific/Fakaofo',
    'Asia/Dili',
    'Asia/Ashgabat',
    'Africa/Tunis',
    'Pacific/Tongatapu',
    'Europe/Istanbul',
    'America/Port_of_Spain',
    'Pacific/Funafuti',
    'Asia/Taipei',
    'Europe/Kiev',
    'Europe/Uzhgorod',
    'Europe/Zaporozhye',
    'Pacific/Wake',
    'America/New_York',
    'America/Detroit',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Indiana/Indianapolis',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Vevay',
    'America/Chicago',
    'America/Indiana/Tell_City',
    'America/Indiana/Knox',
    'America/Menominee',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/North_Dakota/Beulah',
    'America/Denver',
    'America/Boise',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'America/Juneau',
    'America/Sitka',
    'America/Metlakatla',
    'America/Yakutat',
    'America/Nome',
    'America/Adak',
    'Pacific/Honolulu',
    'America/Montevideo',
    'Asia/Samarkand',
    'Asia/Tashkent',
    'America/Caracas',
    'Asia/Ho_Chi_Minh',
    'Pacific/Efate',
    'Pacific/Wallis',
    'Pacific/Apia',
    'Africa/Johannesburg',
    'UTC',
];
/**
 * Object with named keys for DateTimeZones values.
 * Use DateTimeZonesIterable for z.enum() calls.
 */
exports.DateTimeZones = {
    'Europe/Andorra': 'Europe/Andorra',
    'Asia/Dubai': 'Asia/Dubai',
    'Asia/Kabul': 'Asia/Kabul',
    'Europe/Tirane': 'Europe/Tirane',
    'Asia/Yerevan': 'Asia/Yerevan',
    'Antarctica/Casey': 'Antarctica/Casey',
    'Antarctica/Davis': 'Antarctica/Davis',
    'Antarctica/DumontDUrville': 'Antarctica/DumontDUrville',
    'Antarctica/Mawson': 'Antarctica/Mawson',
    'Antarctica/Palmer': 'Antarctica/Palmer',
    'Antarctica/Rothera': 'Antarctica/Rothera',
    'Antarctica/Syowa': 'Antarctica/Syowa',
    'Antarctica/Troll': 'Antarctica/Troll',
    'Antarctica/Vostok': 'Antarctica/Vostok',
    'America/Argentina/Buenos_Aires': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Cordoba': 'America/Argentina/Cordoba',
    'America/Argentina/Salta': 'America/Argentina/Salta',
    'America/Argentina/Jujuy': 'America/Argentina/Jujuy',
    'America/Argentina/Tucuman': 'America/Argentina/Tucuman',
    'America/Argentina/Catamarca': 'America/Argentina/Catamarca',
    'America/Argentina/La_Rioja': 'America/Argentina/La_Rioja',
    'America/Argentina/San_Juan': 'America/Argentina/San_Juan',
    'America/Argentina/Mendoza': 'America/Argentina/Mendoza',
    'America/Argentina/San_Luis': 'America/Argentina/San_Luis',
    'America/Argentina/Rio_Gallegos': 'America/Argentina/Rio_Gallegos',
    'America/Argentina/Ushuaia': 'America/Argentina/Ushuaia',
    'Pacific/Pago_Pago': 'Pacific/Pago_Pago',
    'Europe/Vienna': 'Europe/Vienna',
    'Australia/Lord_Howe': 'Australia/Lord_Howe',
    'Antarctica/Macquarie': 'Antarctica/Macquarie',
    'Australia/Hobart': 'Australia/Hobart',
    'Australia/Currie': 'Australia/Currie',
    'Australia/Melbourne': 'Australia/Melbourne',
    'Australia/Sydney': 'Australia/Sydney',
    'Australia/Broken_Hill': 'Australia/Broken_Hill',
    'Australia/Brisbane': 'Australia/Brisbane',
    'Australia/Lindeman': 'Australia/Lindeman',
    'Australia/Adelaide': 'Australia/Adelaide',
    'Australia/Darwin': 'Australia/Darwin',
    'Australia/Perth': 'Australia/Perth',
    'Australia/Eucla': 'Australia/Eucla',
    'Asia/Baku': 'Asia/Baku',
    'America/Barbados': 'America/Barbados',
    'Asia/Dhaka': 'Asia/Dhaka',
    'Europe/Brussels': 'Europe/Brussels',
    'Europe/Sofia': 'Europe/Sofia',
    'Atlantic/Bermuda': 'Atlantic/Bermuda',
    'Asia/Brunei': 'Asia/Brunei',
    'America/La_Paz': 'America/La_Paz',
    'America/Noronha': 'America/Noronha',
    'America/Belem': 'America/Belem',
    'America/Fortaleza': 'America/Fortaleza',
    'America/Recife': 'America/Recife',
    'America/Araguaina': 'America/Araguaina',
    'America/Maceio': 'America/Maceio',
    'America/Bahia': 'America/Bahia',
    'America/Sao_Paulo': 'America/Sao_Paulo',
    'America/Campo_Grande': 'America/Campo_Grande',
    'America/Cuiaba': 'America/Cuiaba',
    'America/Santarem': 'America/Santarem',
    'America/Porto_Velho': 'America/Porto_Velho',
    'America/Boa_Vista': 'America/Boa_Vista',
    'America/Manaus': 'America/Manaus',
    'America/Eirunepe': 'America/Eirunepe',
    'America/Rio_Branco': 'America/Rio_Branco',
    'America/Nassau': 'America/Nassau',
    'Asia/Thimphu': 'Asia/Thimphu',
    'Europe/Minsk': 'Europe/Minsk',
    'America/Belize': 'America/Belize',
    'America/St_Johns': 'America/St_Johns',
    'America/Halifax': 'America/Halifax',
    'America/Glace_Bay': 'America/Glace_Bay',
    'America/Moncton': 'America/Moncton',
    'America/Goose_Bay': 'America/Goose_Bay',
    'America/Blanc-Sablon': 'America/Blanc-Sablon',
    'America/Toronto': 'America/Toronto',
    'America/Nipigon': 'America/Nipigon',
    'America/Thunder_Bay': 'America/Thunder_Bay',
    'America/Iqaluit': 'America/Iqaluit',
    'America/Pangnirtung': 'America/Pangnirtung',
    'America/Atikokan': 'America/Atikokan',
    'America/Winnipeg': 'America/Winnipeg',
    'America/Rainy_River': 'America/Rainy_River',
    'America/Resolute': 'America/Resolute',
    'America/Rankin_Inlet': 'America/Rankin_Inlet',
    'America/Regina': 'America/Regina',
    'America/Swift_Current': 'America/Swift_Current',
    'America/Edmonton': 'America/Edmonton',
    'America/Cambridge_Bay': 'America/Cambridge_Bay',
    'America/Yellowknife': 'America/Yellowknife',
    'America/Inuvik': 'America/Inuvik',
    'America/Creston': 'America/Creston',
    'America/Dawson_Creek': 'America/Dawson_Creek',
    'America/Fort_Nelson': 'America/Fort_Nelson',
    'America/Vancouver': 'America/Vancouver',
    'America/Whitehorse': 'America/Whitehorse',
    'America/Dawson': 'America/Dawson',
    'Indian/Cocos': 'Indian/Cocos',
    'Europe/Zurich': 'Europe/Zurich',
    'Africa/Abidjan': 'Africa/Abidjan',
    'Pacific/Rarotonga': 'Pacific/Rarotonga',
    'America/Santiago': 'America/Santiago',
    'America/Punta_Arenas': 'America/Punta_Arenas',
    'Pacific/Easter': 'Pacific/Easter',
    'Asia/Shanghai': 'Asia/Shanghai',
    'Asia/Urumqi': 'Asia/Urumqi',
    'America/Bogota': 'America/Bogota',
    'America/Costa_Rica': 'America/Costa_Rica',
    'America/Havana': 'America/Havana',
    'Atlantic/Cape_Verde': 'Atlantic/Cape_Verde',
    'America/Curacao': 'America/Curacao',
    'Indian/Christmas': 'Indian/Christmas',
    'Asia/Nicosia': 'Asia/Nicosia',
    'Asia/Famagusta': 'Asia/Famagusta',
    'Europe/Prague': 'Europe/Prague',
    'Europe/Berlin': 'Europe/Berlin',
    'Europe/Copenhagen': 'Europe/Copenhagen',
    'America/Santo_Domingo': 'America/Santo_Domingo',
    'Africa/Algiers': 'Africa/Algiers',
    'America/Guayaquil': 'America/Guayaquil',
    'Pacific/Galapagos': 'Pacific/Galapagos',
    'Europe/Tallinn': 'Europe/Tallinn',
    'Africa/Cairo': 'Africa/Cairo',
    'Africa/El_Aaiun': 'Africa/El_Aaiun',
    'Europe/Madrid': 'Europe/Madrid',
    'Africa/Ceuta': 'Africa/Ceuta',
    'Atlantic/Canary': 'Atlantic/Canary',
    'Europe/Helsinki': 'Europe/Helsinki',
    'Pacific/Fiji': 'Pacific/Fiji',
    'Atlantic/Stanley': 'Atlantic/Stanley',
    'Pacific/Chuuk': 'Pacific/Chuuk',
    'Pacific/Pohnpei': 'Pacific/Pohnpei',
    'Pacific/Kosrae': 'Pacific/Kosrae',
    'Atlantic/Faroe': 'Atlantic/Faroe',
    'Europe/Paris': 'Europe/Paris',
    'Europe/London': 'Europe/London',
    'Asia/Tbilisi': 'Asia/Tbilisi',
    'America/Cayenne': 'America/Cayenne',
    'Africa/Accra': 'Africa/Accra',
    'Europe/Gibraltar': 'Europe/Gibraltar',
    'America/Godthab': 'America/Godthab',
    'America/Danmarkshavn': 'America/Danmarkshavn',
    'America/Scoresbysund': 'America/Scoresbysund',
    'America/Thule': 'America/Thule',
    'Europe/Athens': 'Europe/Athens',
    'Atlantic/South_Georgia': 'Atlantic/South_Georgia',
    'America/Guatemala': 'America/Guatemala',
    'Pacific/Guam': 'Pacific/Guam',
    'Africa/Bissau': 'Africa/Bissau',
    'America/Guyana': 'America/Guyana',
    'Asia/Hong_Kong': 'Asia/Hong_Kong',
    'America/Tegucigalpa': 'America/Tegucigalpa',
    'America/Port-au-Prince': 'America/Port-au-Prince',
    'Europe/Budapest': 'Europe/Budapest',
    'Asia/Jakarta': 'Asia/Jakarta',
    'Asia/Pontianak': 'Asia/Pontianak',
    'Asia/Makassar': 'Asia/Makassar',
    'Asia/Jayapura': 'Asia/Jayapura',
    'Europe/Dublin': 'Europe/Dublin',
    'Asia/Jerusalem': 'Asia/Jerusalem',
    'Asia/Kolkata': 'Asia/Kolkata',
    'Indian/Chagos': 'Indian/Chagos',
    'Asia/Baghdad': 'Asia/Baghdad',
    'Asia/Tehran': 'Asia/Tehran',
    'Atlantic/Reykjavik': 'Atlantic/Reykjavik',
    'Europe/Rome': 'Europe/Rome',
    'America/Jamaica': 'America/Jamaica',
    'Asia/Amman': 'Asia/Amman',
    'Asia/Tokyo': 'Asia/Tokyo',
    'Africa/Nairobi': 'Africa/Nairobi',
    'Asia/Bishkek': 'Asia/Bishkek',
    'Pacific/Tarawa': 'Pacific/Tarawa',
    'Pacific/Enderbury': 'Pacific/Enderbury',
    'Pacific/Kiritimati': 'Pacific/Kiritimati',
    'Asia/Pyongyang': 'Asia/Pyongyang',
    'Asia/Seoul': 'Asia/Seoul',
    'Asia/Almaty': 'Asia/Almaty',
    'Asia/Qyzylorda': 'Asia/Qyzylorda',
    'Asia/Qostanay': 'Asia/Qostanay',
    'Asia/Aqtobe': 'Asia/Aqtobe',
    'Asia/Aqtau': 'Asia/Aqtau',
    'Asia/Atyrau': 'Asia/Atyrau',
    'Asia/Oral': 'Asia/Oral',
    'Asia/Beirut': 'Asia/Beirut',
    'Asia/Colombo': 'Asia/Colombo',
    'Africa/Monrovia': 'Africa/Monrovia',
    'Europe/Vilnius': 'Europe/Vilnius',
    'Europe/Luxembourg': 'Europe/Luxembourg',
    'Europe/Riga': 'Europe/Riga',
    'Africa/Tripoli': 'Africa/Tripoli',
    'Africa/Casablanca': 'Africa/Casablanca',
    'Europe/Monaco': 'Europe/Monaco',
    'Europe/Chisinau': 'Europe/Chisinau',
    'Pacific/Majuro': 'Pacific/Majuro',
    'Pacific/Kwajalein': 'Pacific/Kwajalein',
    'Asia/Yangon': 'Asia/Yangon',
    'Asia/Ulaanbaatar': 'Asia/Ulaanbaatar',
    'Asia/Hovd': 'Asia/Hovd',
    'Asia/Choibalsan': 'Asia/Choibalsan',
    'Asia/Macau': 'Asia/Macau',
    'America/Martinique': 'America/Martinique',
    'Europe/Malta': 'Europe/Malta',
    'Indian/Mauritius': 'Indian/Mauritius',
    'Indian/Maldives': 'Indian/Maldives',
    'America/Mexico_City': 'America/Mexico_City',
    'America/Cancun': 'America/Cancun',
    'America/Merida': 'America/Merida',
    'America/Monterrey': 'America/Monterrey',
    'America/Matamoros': 'America/Matamoros',
    'America/Mazatlan': 'America/Mazatlan',
    'America/Chihuahua': 'America/Chihuahua',
    'America/Ojinaga': 'America/Ojinaga',
    'America/Hermosillo': 'America/Hermosillo',
    'America/Tijuana': 'America/Tijuana',
    'America/Bahia_Banderas': 'America/Bahia_Banderas',
    'Asia/Kuala_Lumpur': 'Asia/Kuala_Lumpur',
    'Asia/Kuching': 'Asia/Kuching',
    'Africa/Maputo': 'Africa/Maputo',
    'Africa/Windhoek': 'Africa/Windhoek',
    'Pacific/Noumea': 'Pacific/Noumea',
    'Pacific/Norfolk': 'Pacific/Norfolk',
    'Africa/Lagos': 'Africa/Lagos',
    'America/Managua': 'America/Managua',
    'Europe/Amsterdam': 'Europe/Amsterdam',
    'Europe/Oslo': 'Europe/Oslo',
    'Asia/Kathmandu': 'Asia/Kathmandu',
    'Pacific/Nauru': 'Pacific/Nauru',
    'Pacific/Niue': 'Pacific/Niue',
    'Pacific/Auckland': 'Pacific/Auckland',
    'Pacific/Chatham': 'Pacific/Chatham',
    'America/Panama': 'America/Panama',
    'America/Lima': 'America/Lima',
    'Pacific/Tahiti': 'Pacific/Tahiti',
    'Pacific/Marquesas': 'Pacific/Marquesas',
    'Pacific/Gambier': 'Pacific/Gambier',
    'Pacific/Port_Moresby': 'Pacific/Port_Moresby',
    'Pacific/Bougainville': 'Pacific/Bougainville',
    'Asia/Manila': 'Asia/Manila',
    'Asia/Karachi': 'Asia/Karachi',
    'Europe/Warsaw': 'Europe/Warsaw',
    'America/Miquelon': 'America/Miquelon',
    'Pacific/Pitcairn': 'Pacific/Pitcairn',
    'America/Puerto_Rico': 'America/Puerto_Rico',
    'Asia/Gaza': 'Asia/Gaza',
    'Asia/Hebron': 'Asia/Hebron',
    'Europe/Lisbon': 'Europe/Lisbon',
    'Atlantic/Madeira': 'Atlantic/Madeira',
    'Atlantic/Azores': 'Atlantic/Azores',
    'Pacific/Palau': 'Pacific/Palau',
    'America/Asuncion': 'America/Asuncion',
    'Asia/Qatar': 'Asia/Qatar',
    'Indian/Reunion': 'Indian/Reunion',
    'Europe/Bucharest': 'Europe/Bucharest',
    'Europe/Belgrade': 'Europe/Belgrade',
    'Europe/Kaliningrad': 'Europe/Kaliningrad',
    'Europe/Moscow': 'Europe/Moscow',
    'Europe/Simferopol': 'Europe/Simferopol',
    'Europe/Kirov': 'Europe/Kirov',
    'Europe/Astrakhan': 'Europe/Astrakhan',
    'Europe/Volgograd': 'Europe/Volgograd',
    'Europe/Saratov': 'Europe/Saratov',
    'Europe/Ulyanovsk': 'Europe/Ulyanovsk',
    'Europe/Samara': 'Europe/Samara',
    'Asia/Yekaterinburg': 'Asia/Yekaterinburg',
    'Asia/Omsk': 'Asia/Omsk',
    'Asia/Novosibirsk': 'Asia/Novosibirsk',
    'Asia/Barnaul': 'Asia/Barnaul',
    'Asia/Tomsk': 'Asia/Tomsk',
    'Asia/Novokuznetsk': 'Asia/Novokuznetsk',
    'Asia/Krasnoyarsk': 'Asia/Krasnoyarsk',
    'Asia/Irkutsk': 'Asia/Irkutsk',
    'Asia/Chita': 'Asia/Chita',
    'Asia/Yakutsk': 'Asia/Yakutsk',
    'Asia/Khandyga': 'Asia/Khandyga',
    'Asia/Vladivostok': 'Asia/Vladivostok',
    'Asia/Ust-Nera': 'Asia/Ust-Nera',
    'Asia/Magadan': 'Asia/Magadan',
    'Asia/Sakhalin': 'Asia/Sakhalin',
    'Asia/Srednekolymsk': 'Asia/Srednekolymsk',
    'Asia/Kamchatka': 'Asia/Kamchatka',
    'Asia/Anadyr': 'Asia/Anadyr',
    'Asia/Riyadh': 'Asia/Riyadh',
    'Pacific/Guadalcanal': 'Pacific/Guadalcanal',
    'Indian/Mahe': 'Indian/Mahe',
    'Africa/Khartoum': 'Africa/Khartoum',
    'Europe/Stockholm': 'Europe/Stockholm',
    'Asia/Singapore': 'Asia/Singapore',
    'America/Paramaribo': 'America/Paramaribo',
    'Africa/Juba': 'Africa/Juba',
    'Africa/Sao_Tome': 'Africa/Sao_Tome',
    'America/El_Salvador': 'America/El_Salvador',
    'Asia/Damascus': 'Asia/Damascus',
    'America/Grand_Turk': 'America/Grand_Turk',
    'Africa/Ndjamena': 'Africa/Ndjamena',
    'Indian/Kerguelen': 'Indian/Kerguelen',
    'Asia/Bangkok': 'Asia/Bangkok',
    'Asia/Dushanbe': 'Asia/Dushanbe',
    'Pacific/Fakaofo': 'Pacific/Fakaofo',
    'Asia/Dili': 'Asia/Dili',
    'Asia/Ashgabat': 'Asia/Ashgabat',
    'Africa/Tunis': 'Africa/Tunis',
    'Pacific/Tongatapu': 'Pacific/Tongatapu',
    'Europe/Istanbul': 'Europe/Istanbul',
    'America/Port_of_Spain': 'America/Port_of_Spain',
    'Pacific/Funafuti': 'Pacific/Funafuti',
    'Asia/Taipei': 'Asia/Taipei',
    'Europe/Kiev': 'Europe/Kiev',
    'Europe/Uzhgorod': 'Europe/Uzhgorod',
    'Europe/Zaporozhye': 'Europe/Zaporozhye',
    'Pacific/Wake': 'Pacific/Wake',
    'America/New_York': 'America/New_York',
    'America/Detroit': 'America/Detroit',
    'America/Kentucky/Louisville': 'America/Kentucky/Louisville',
    'America/Kentucky/Monticello': 'America/Kentucky/Monticello',
    'America/Indiana/Indianapolis': 'America/Indiana/Indianapolis',
    'America/Indiana/Vincennes': 'America/Indiana/Vincennes',
    'America/Indiana/Winamac': 'America/Indiana/Winamac',
    'America/Indiana/Marengo': 'America/Indiana/Marengo',
    'America/Indiana/Petersburg': 'America/Indiana/Petersburg',
    'America/Indiana/Vevay': 'America/Indiana/Vevay',
    'America/Chicago': 'America/Chicago',
    'America/Indiana/Tell_City': 'America/Indiana/Tell_City',
    'America/Indiana/Knox': 'America/Indiana/Knox',
    'America/Menominee': 'America/Menominee',
    'America/North_Dakota/Center': 'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem': 'America/North_Dakota/New_Salem',
    'America/North_Dakota/Beulah': 'America/North_Dakota/Beulah',
    'America/Denver': 'America/Denver',
    'America/Boise': 'America/Boise',
    'America/Phoenix': 'America/Phoenix',
    'America/Los_Angeles': 'America/Los_Angeles',
    'America/Anchorage': 'America/Anchorage',
    'America/Juneau': 'America/Juneau',
    'America/Sitka': 'America/Sitka',
    'America/Metlakatla': 'America/Metlakatla',
    'America/Yakutat': 'America/Yakutat',
    'America/Nome': 'America/Nome',
    'America/Adak': 'America/Adak',
    'Pacific/Honolulu': 'Pacific/Honolulu',
    'America/Montevideo': 'America/Montevideo',
    'Asia/Samarkand': 'Asia/Samarkand',
    'Asia/Tashkent': 'Asia/Tashkent',
    'America/Caracas': 'America/Caracas',
    'Asia/Ho_Chi_Minh': 'Asia/Ho_Chi_Minh',
    'Pacific/Efate': 'Pacific/Efate',
    'Pacific/Wallis': 'Pacific/Wallis',
    'Pacific/Apia': 'Pacific/Apia',
    'Africa/Johannesburg': 'Africa/Johannesburg',
    UTC: 'UTC',
};
exports.FrequencyPeriodIterable = [
    'day',
    'week',
    'month',
    'quarter',
    'year',
];
/**
 * Object with named keys for FrequencyPeriod values.
 * Use FrequencyPeriodIterable for z.enum() calls.
 */
exports.FrequencyPeriod = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
};
exports.FrequencyTypeIterable = ['rolling', 'calendar'];
/**
 * Object with named keys for FrequencyType values.
 * Use FrequencyTypeIterable for z.enum() calls.
 */
exports.FrequencyType = {
    Rolling: 'rolling',
    Calendar: 'calendar',
};
exports.EncryptionTypeSchema = zod_1.z.enum(['gpg']);
exports.EncryptionConfigSchema = zod_1.z.object({
    privateKeySsmPath: zod_1.z.string(),
    encryptionType: exports.EncryptionTypeSchema,
    isEncryptedDataArmored: zod_1.z.boolean().optional(),
    passphraseSsmPath: zod_1.z.string().optional(),
});
exports.SftpConfigSchema = zod_1.z.object({
    authType: zod_1.z
        .enum(['password', 'privateKey'])
        .describe('Authentication type: password or privateKey'),
    host: zod_1.z.string().describe('SFTP host'),
    port: zod_1.z.number().optional().describe('SFTP port (optional)'),
    username: zod_1.z.string().describe('SFTP username'),
    ssmCredPath: zod_1.z.string().describe('SSM credential path'),
    rootPath: zod_1.z.string().optional().describe('Root path (optional)'),
});
//# sourceMappingURL=Utils.js.map